import { render, staticRenderFns } from "./ModalEditBusiness.vue?vue&type=template&id=127fec5b&scoped=true&"
import script from "./ModalEditBusiness.vue?vue&type=script&lang=js&"
export * from "./ModalEditBusiness.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ModalEditBusiness.vue?vue&type=style&index=1&id=127fec5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127fec5b",
  null
  
)

export default component.exports